import React from 'react';
import { goToCheckout } from '../utils/checkout';
export function Footer() {
  return <footer className="bg-[#050505] py-12 px-4 text-center border-t border-brand-gray" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <h3 className="text-2xl md:text-4xl font-display font-bold text-white uppercase mb-8" data-id="element-53">
          Tu reinicio empieza hoy.
        </h3>

        <button onClick={goToCheckout} className="bg-brand-orange hover:bg-[#ff7b1a] text-black font-display font-bold text-lg md:text-xl py-4 px-8 rounded-sm transition-all uppercase tracking-wide mb-16" data-id="element-54">
          Obtener Acceso Inmediato
        </button>

        <div className="text-brand-muted/60 text-xs space-y-4 max-w-3xl mx-auto" data-id="element-55">
          <p data-id="element-56">
            DESCARGO DE RESPONSABILIDAD: La información proporcionada en este
            sitio web y en el Protocolo Alpha es solo para fines educativos e
            informativos. No pretende ser un sustituto del consejo médico
            profesional, diagnóstico o tratamiento. Siempre busque el consejo de
            su médico u otro proveedor de salud calificado con cualquier
            pregunta que pueda tener con respecto a una condición médica.
          </p>
          <div className="flex justify-center gap-4 pt-4 border-t border-brand-gray/30" data-id="element-57">
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-58">
              Términos y Condiciones
            </a>
            <span data-id="element-59">|</span>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-60">
              Política de Privacidad
            </a>
            <span data-id="element-61">|</span>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-62">
              Contacto
            </a>
          </div>
          <p className="pt-4" data-id="element-63">
            &copy; {new Date().getFullYear()} Alpha Protocol. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}